import { AROApiUrl, AROApiKey } from "../utils/config";

/** Error from the ARO API. `detail` keeps the server's structured body (e.g. missing columns on import). */
export class AroApiError extends Error {
  detail: any;

  constructor(detail: any) {
    super(typeof detail === "string" ? detail : detail?.message || "Request failed");
    this.detail = detail;
  }
}

async function throwApiError(res: Response): Promise<never> {
  const err = await res.json().catch(() => ({ detail: "Unknown error" }));
  throw new AroApiError(err.detail || "Request failed");
}

export async function aroFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${AROApiUrl()}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": AROApiKey(),
      ...(options?.headers || {}),
    },
  });

  if (!res.ok) return throwApiError(res);

  return res.json();
}

export async function aroFetchForm<T>(path: string, formData: FormData): Promise<T> {
  const res = await fetch(`${AROApiUrl()}${path}`, {
    method: "POST",
    headers: { "X-API-Key": AROApiKey() },
    body: formData,
  });

  if (!res.ok) return throwApiError(res);

  return res.json();
}

export async function aroFetchBlob(path: string): Promise<Blob> {
  const res = await fetch(`${AROApiUrl()}${path}`, {
    headers: { "X-API-Key": AROApiKey() },
  });

  if (!res.ok) throw new Error("Export failed");
  return res.blob();
}
